"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // ARCHITECT-MIXINS [ MAKE > LIST ] ############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var setDirection = function setDirection(dir) {
  if (dir && dir === 'column') {
    return "\n      flex-direction: column!important;\n      li {\n        &:not(:last-child) {\n          margin-bottom: var(--gutter-small);\n        }\n      }\n    ";
  }

  ;
  return "\n    flex-direction: row;\n    align-items: center;\n\n    li {\n      &:not(:last-child) {\n        margin-right: var(--gutter-small);\n      }\n    }\n  ";
};

var _default = function _default(direction) {
  return "\n  display: flex;\n  flex-direction: row;\n\n  margin: 0;\n  padding: 0;\n\n  li {\n    &:before {\n      display: none;\n    }\n    &:marker {\n      display: none;\n    }\n    padding-left: 0;\n  }\n\n  ".concat(setDirection(direction), "\n    \n");
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports["default"] = _default;